class IC {
  public static counters = new Map<string, number>()
  public static add(name: string) {
    const count = this.counters.get(name) ?? 0
    this.counters.set(name, count + 1)
  }
  public static toJSON() {
    const json: { [key: string]: number } = {}
    this.counters.forEach((value, key) => {
      json[key] = value
    })
    return json
  }
}

export default IC
